import * as H from "history";
import { Action, Reducer } from 'redux';
import { SurveyLocalStorageManager } from '../../Managers/SurveyLocalStorageManager';
import { ResultType } from '../../Models/Api/ApiResponse';
import { SharedMaterialsCatalogCompany } from '../../Models/SharedMaterials/DataModel';
import { MatchedInventory, MatchedSharedMaterialCoreData, SurveyMatchData } from '../../Models/Surveys/SurveyMatchDataModel';
import { AppThunkAction } from './../../';
import { ToxnotServiceClient } from './../../ToxnotServiceClient';


const SurveySetSurveyMatchData = "SET_SURVEYMATCH_DATA";
interface SurveySetSurveyMatchData {
    type: typeof SurveySetSurveyMatchData;
    value: Partial<SurveyMatchData>
}

const initialState: SurveyMatchData = {
    sharedMaterials: {},
    companies: {},
    matchFound: true,
    matchedInventories: [],
    showConfirmationModel: false,
    tempInventoryId: null,
    tempSharedMaterialId: null,
    overwritingInProgress: false,
    surveyResultsLoaded: false
}

type KnownAction =  SurveySetSurveyMatchData;

export const actionCreators = {
    setSurveyMatchState: (value: Partial<SurveyMatchData>): AppThunkAction<KnownAction> => (dispatch, getState) => {
        const state = getState().surveyMatchState;
        if (!state) {
            return;
        }
        dispatch({
            type: SurveySetSurveyMatchData,
            value: value
        })
    },
    copyIntoLibrary: (sharedMaterialId: string, inventoryId: string): AppThunkAction<KnownAction> => (dispatch, getState) => {
        const state = getState().surveyMatchState;
        if (!state) {
            return;
        }
        saveCopyToLibrary(sharedMaterialId, inventoryId, dispatch, state);
    },
    removeInventory: (inventoryId: string): AppThunkAction<KnownAction> => (dispatch, getState) => {
        const state = getState().surveyMatchState;
        if (!state) {
            return;
        }
    },
    continue: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
        const appState = getState();
        const surveyMatchState = appState.surveyMatchState;

        if (!surveyMatchState) {
            return;
        }
    },
    overwriteConfirmation: (sharedMaterialId: string, inventoryId: string): AppThunkAction<KnownAction> => (dispatch, getState) => {
        const state = getState().surveyMatchState;
        if (!state) {
            return;
        }
        dispatch({
            type: SurveySetSurveyMatchData,
            value: {
                showConfirmationModel: true,
                tempInventoryId: inventoryId,
                tempSharedMaterialId: sharedMaterialId
            }
        })
        $("#show-confirmation-modal").modal("show");
    },
    overwrite: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
        const state = getState().surveyMatchState;
        if (!state) {
            return;
        }
        dispatch({
            type: SurveySetSurveyMatchData,
            value: {
                overwritingInProgress: true,
            }
        })
        overwriteData(dispatch, state);
    }
}

async function saveCopyToLibrary(sharedMaterialId: string, inventoryId: string, dispatch: (action: KnownAction) => void, state: SurveyMatchData) {
    const serviceClient = new ToxnotServiceClient();
    const apiResult = await serviceClient.addSharedMaterialToLibrary(sharedMaterialId);
}

async function overwriteData(dispatch: (action: KnownAction) => void, state: SurveyMatchData) {
    const serviceClient = new ToxnotServiceClient();
    if (state.tempSharedMaterialId === null || state.tempInventoryId === null) {
        return;
    }
    const apiResult = await serviceClient.copySharedMaterialDataIntoLibraryInventory(state.tempSharedMaterialId, state.tempInventoryId);
}

export const reducer: Reducer<SurveyMatchData> = (state: SurveyMatchData | undefined, action: Action): SurveyMatchData => { 
    if (state === undefined) {
        return initialState;
    }
    let incomingAction;
    switch (action.type) {
        case SurveySetSurveyMatchData:
            incomingAction = action as SurveySetSurveyMatchData;
            return {
                ...state,
                ...incomingAction.value
            }
        
    }
    return state;
}